import CaptureSettings from "./CaptureSettings";
import VerificationSettings from "./VerificationSettings";

export enum AccountDomainStatus {
    Verified = "verified",
    Pending = "pending",
    Error = "error"
}

export default interface AccountDomain {
    _id: string;
    name: string;
    status: AccountDomainStatus;
    createdAt: string;
    updatedAt: string;
    verifiedAt?: string;
    captureSettings?: CaptureSettings;
    verificationSettings: VerificationSettings;
}
